var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.farmUnits.length > 0)?_c('Dropdown',{attrs:{"options":_vm.farmUnits,"disabled":_vm.disabled,"textValue":_vm.displayValue},on:{"select":_vm.selectFarmUnit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }